import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import FooterDefault from "./FooterDefault";
import NavbarDefault from "./NavbarDefault";

const DefaultLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <NavbarDefault />

      <div className="min-h-screen bg-white w-full">
        <Outlet />
      </div>

      <FooterDefault />
    </>
  );
};

export default DefaultLayout;
